import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';
import { LoginLayoutComponent } from './shared/layouts/login-layout/login-layout.component';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { LoginGoogleComponent } from './shared/layouts/login-google/login-google.component';
import { LoginComponent } from './views/login/login.component';
import { ErrorLayoutComponent } from './shared/layouts/error-layout/error-layout.component';
import { HosesDepartmentRoutes } from '@dep-hoses/routes';
import { FilterDepartmentRoutes } from '@dep/filters/routes';
import { HrDepartmentRoutes } from './features/hr/routes';
import { TanksDepartmentRoutes } from '@dep-tanks/routes';
import { LidsDepartmentRoutes } from '@dep-lids/routes';

const errorRouteConfig = (status: number) => {
  return {
    component: ErrorLayoutComponent,
    data: {
      pageTitle: '',
      status,
    },
  };
};

const routes: Routes = [
  {
    path: 'sb',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/sb/scanner-v2/info' },
      {
        path: 'unauthorized',
        ...errorRouteConfig(401),
      },
      {
        path: 'not-found',
        ...errorRouteConfig(404),
      },
      {
        path: 'forbidden',
        ...errorRouteConfig(403),
      },
      {
        path: 'scanner-v2',
        loadChildren: () =>
          import('./features/packing-tracker/packing-tracker.module').then(
            (m) => m.PackingTrackerModule
          ),
      },
      {
        path: 'intakes',
        loadChildren: () =>
          import('./features/intakes/intakes.module').then(
            (m) => m.IntakesModule
          ),
      },
      {
        path: 'hp',
        loadChildren: () =>
          import('./features/hps/hps.module').then((m) => m.HpsModule),
      },
      {
        path: 'plastic',
        loadChildren: () =>
          import('./features/plastic/plastic.module').then(
            (m) => m.PlasticModule
          ),
      },
      {
        path: 'cortes',
        loadChildren: () =>
          import('./features/cortes/cortes-routing.module').then(
            (m) => m.CortesRoutingModule
          ),
      },
      {
        path: 'nave4',
        loadChildren: () =>
          import('./features/nave4/nave4.module').then((m) => m.Nave4Module),
      },
      // {
      //   path: 'reports',
      //   loadChildren: () =>
      //     import('./modules/reports/reports.module').then(
      //       (m) => m.ReportsModule
      //     ),
      // },
      {
        path: 'reportsPBI',
        loadChildren: () =>
          import('./features/powerbi/powerbi.module').then(
            (m) => m.PowerBiModule
          ),
      },
      TanksDepartmentRoutes,
      {
        path: 'compression',
        loadChildren: () =>
          import('./features/compression/compression-molding.module').then(
            (m) => m.CompressionMoldingModule
          ),
      },
      FilterDepartmentRoutes,
      {
        path: 'cnc',
        loadChildren: () =>
          import('./features/cnc/cnc.module').then((m) => m.CncModule),
      },
      {
        path: 'compounding',
        loadChildren: () =>
          import('./features/compounding/compounding.module').then(
            (m) => m.CompoundingModule
          ),
      },
      HosesDepartmentRoutes,
      HrDepartmentRoutes,
      {
        path: 'shiphawk/generate-excel',
        loadChildren: () =>
          import('./modules-shiphawk/order-to-excel/order-excel.module').then(
            (m) => m.SHOrderExcelModule
          ),
      },
      {
        path: 'pliegues',
        loadChildren: () =>
          import('./features/pleat-packs/pleat-packs.module').then(
            (m) => m.PleatPacksModule
          ),
      },
      LidsDepartmentRoutes,
      {
        path: 'injection-molding',
        loadChildren: () =>
          import('./features/injection-molding/injection-molding.module').then(
            (m) => m.InjectionMoldingModule
          ),
      },
      {
        path: 'polyurethane',
        loadChildren: () =>
          import('./features/polyurethane/polyurethane.module').then(
            (m) => m.PolyurethaneModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'management',
        loadChildren: () =>
          import('./features/management/management.module').then(
            (m) => m.ManagementModule
          ),
      },
      {
        path: 'shipping-receive',
        loadChildren: () =>
          import('./features/shipping-receive/shipping-receive.module').then(
            (m) => m.ShippingReceiveModule
          ),
      },
      {
        path: 'efficiencies',
        loadChildren: () =>
          import('./features/efficiencies/efficiencies.module').then(
            (m) => m.EfficienciesModule
          ),
      },
      {
        path: 'daily-planning',
        loadChildren: () =>
          import('./features/daily-planning/daily-planning.module').then(
            (m) => m.DailyPlanningModule
          ),
      },
      {
        path: 'competences',
        loadChildren: () =>
          import('./features/competences/competences.module').then(
            (m) => m.CompetencesModule
          ),
      },
    ],
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
      },
    ],
  },
  {
    path: 'login/google',
    component: LoginGoogleComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
